module.exports = __webpack_public_path__ + "img/canon_logo.5dc32a47.svg";